import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { CurrLotteryModel, PlayModeModel, PlayDetailModel,CachedModel,StorageLottery } from '../../models/betting.model';
import { StorageService } from '../../providers/storage.service';
import { GroupByPipe } from 'ng-pipes';
import { PlaySelectService } from '../../services/playselect.service';
import { PlaySelectModel } from '../../models/bettingorder.dto';
/*
  投注选择页面
  chen 2017-03-01
*/
@Component({
    selector: 'play-select',
    templateUrl: 'playSelect.html',
    providers: [GroupByPipe]
})
export class PlaySelectPage {
    lotteryCode = '10001';
    currlottery = new CurrLotteryModel();
    playModes: PlayModeModel[];
    playMode: PlayModeModel;
    playDetails: PlayDetailModel[];
    demoplayModes: PlayModeModel[];
    currPlayDetails;
    currPlayDetail: PlayDetailModel;
    currDetailName = "";
    playGroup = "";
    currModel: StorageLottery;
    track: CachedModel;
    tracks: PlaySelectModel;
    trackshis: CachedModel[];
    trackId: number = -1;
    isPropClose: boolean = false;
    constructor(
        private viewCtrl: ViewController,
        private navPar: NavParams,
        private storage: StorageService,
        private groupBy: GroupByPipe,
        private playSelectService: PlaySelectService

    ) {
        this.tracks = new PlaySelectModel();
        this.lotteryCode = this.navPar.get("lotteryCode");
        this.currlottery = this.navPar.get("currlottery");
        this.currDetailName = this.navPar.get("currPlayDetailName");
        this.playModes = this.currlottery.PlayModes;
        this.playMode = this.currlottery.PlayMode;
        this.playDetails = this.playMode.PlayDetails;
        this.playGroup = this.navPar.get("PlayGroup");
    }

    //页面初始加载
    //chen 2017-03-02
    ionViewDidLoad() {
        this.onPlayModeClick(this.currlottery.PlayMode);
    }

    //模式点击事件
    //chen 2017-03-01
    onPlayModeClick(x: PlayModeModel) {
        this.playMode = x;
        let playDetails = this.groupBy.transform(x.PlayDetails, "PlayGroup");
        let firstArray: PlayDetailModel[][] = [];
        let lastArray: PlayDetailModel[][] = [];
        for (var i in playDetails) {
            let details: PlayDetailModel[] = playDetails[i];
            if (playDetails[i]["PlayGroup"]) {
                firstArray.push(details);
            } else {
                lastArray.push(details);
            }
        }
        this.currPlayDetails = firstArray.concat(lastArray);
        this.currDetailName = x.LotteryPlayModeCode != this.currlottery.PlayMode.LotteryPlayModeCode ? "" : this.currDetailName;
        if (x.PlayDetails && x.PlayDetails[0]) {
            this.currPlayDetail = x.PlayDetails[0];
            this.currDetailName = this.currDetailName ? this.currDetailName : x.PlayDetails[0].LotteryPlayDetailName;
            this.playGroup = x.PlayDetails[0].PlayGroup;
            this.tracks = {
                playMode: this.playMode,
                playDetailName: this.currDetailName,
                playDetail: this.currPlayDetail,
                PlayGroup: this.playGroup
            };
            this.playSelectService.setPlaySelectModel(this.tracks);
        }
        this.currModel = new StorageLottery();
        this.currModel.LotteryCode = x.LotteryPlayModeCode;
        this.currModel.LotteryName = x.LotteryPlayModeName;
        this.trackshis = this.storage.read<CachedModel[]>("cachedPlay" + this.lotteryCode);
        this.trackshis = this.trackshis ? this.trackshis : [];
        // this.currDetailName=this.currDetailName=="" || x.LotteryPlayModeCode!=this.currlottery.PlayMode.LotteryPlayModeCode? x.PlayDetails[0].LotteryPlayDetailName:this.currDetailName;
    }

    //玩法细节点击
    //chen 2017-03-02
    initPlayDetail(x: PlayDetailModel,flag) {
        this.trackId = this.trackshis.findIndex(s => s.PlayDetail.LotteryPlayDetailCode == x.LotteryPlayDetailCode);
        if (!flag) {
            this.track = {
                PlayMode: this.currModel,
                PlayDetail: x
                // PlayDetail:this.currPlayDetail,

            };
            if (this.trackId < 0) {
                this.trackshis.unshift(this.track);
                if (this.trackshis.length > 3) {
                    this.trackshis.pop();
                }
            }
        } else {
            this.track = this.tracks[this.trackId];
            if (this.trackId > 0) {
                this.trackshis.splice(this.trackId, 1);
                this.trackshis.unshift(this.track);
            }
        }
        this.trackId = 0;
        let index = this.playModes.findIndex(s => s.LotteryPlayModeCode == this.track.PlayMode.LotteryCode);
        this.currlottery.PlayMode = this.playModes[index];
        this.storage.write("cachedPlay" + this.lotteryCode, this.trackshis);
        this.currPlayDetail = x;
        this.currDetailName = x.LotteryPlayDetailName;
        this.playGroup = x.PlayGroup;
        this.close();
    }

    //弹窗关闭
    //chen 2017--3-02
    close() {
        this.tracks = {
            playMode: this.playMode,
            playDetailName: this.currDetailName,
            playDetail: this.currPlayDetail,
            PlayGroup: this.playGroup,
        };
        this.viewCtrl.dismiss(this.tracks);
    }
}


// WEBPACK FOOTER //
// ./src/pages/bettingorder/playSelect.ts